{
    "footer.waclink.clicked": ["sdVersion", "sessionId", "version", "context"],
    "search.overlay.button.clicked": ["sdVersion", "sessionId", "version", "context"],
    "session.logout.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "header.avatar.menu.opened": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.profile.clicked": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.logout.clicked": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.my.request.clicked": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.all.requests.clicked": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.pending.approval.clicked": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.my.approval.clicked": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.organisation.clicked": ["sdVersion", "sessionId", "version", "context"],
    "header.avatar.menu.spotlight.clicked": ["sdVersion", "sessionId", "version", "context"],
    "kbPortalView.helpful.clicked": ["sdVersion", "sessionId", "version", "context"],
    "kbPortalView.not.helpful.clicked": ["sdVersion", "sessionId", "version", "context"],
    "request.change.spotlight.dismiss.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "search.result.kb.clicked": [
        "sdVersion",
        "sessionId",
        "version",
        "context",
        "hash",
        "q_len",
        "total_idx",
        "total_count",
        "category_idx",
        "category_count"
    ],
    "search.result.portal.clicked": [
        "sdVersion",
        "sessionId",
        "version",
        "context",
        "hash",
        "q_len",
        "total_idx",
        "total_count",
        "category_idx",
        "category_count"
    ],
    "search.result.request.clicked": [
        "sdVersion",
        "sessionId",
        "version",
        "context",
        "hash",
        "q_len",
        "total_idx",
        "total_count",
        "category_idx",
        "category_count"
    ],
    "sentry.error.tracking.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "helpcenter.search.textbox.focused": ["sdVersion", "sessionId", "version", "context"],
    "helpcenter.search.textbox.submit": ["sdVersion", "sessionId", "version", "context"],
    "portal.search.onboarding.dismiss.clicked": ["sdVersion", "sessionId", "version", "context"],
    "portal.search.onboarding.target.clicked": ["sdVersion", "sessionId", "version", "context"],
    "spotlight.dismiss.failed": ["sdVersion", "sessionId", "version", "context", "spotlightKey", "error"],
    "servicedesk.customerview.smartportal.browse.popular.portals.portal.clicked": [
        "index",
        "sdVersion",
        "sessionId",
        "portalFrontendBuildKey"
    ],
    "servicedesk.customerview.smartportal.browse.popular.portals.browse.all.clicked": [
        "sdVersion",
        "sessionId",
        "version",
        "context"
    ],
    "organisation.fetch.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "kbsuggestions.fetch.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "findlabel.fetch.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "finduser.fetch.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "servicedesk.customerview.smartportal.browse.recent.requesttypes.requesttype.clicked": [
        "index",
        "sdVersion",
        "sessionId",
        "version"
    ],
    "add.announcement.sidebar.content": ["index", "sdVersion", "sessionId", "version"],
    "add.announcement.sidebar.content.save.clicked": ["index", "sdVersion", "sessionId", "version"],
    "add.announcement.sidebar.content.cancel.clicked": ["index", "sdVersion", "sessionId", "version"],
    "async.loader.failed": ["sdVersion", "sessionId", "version", "context", "error"],
    "portal.home.announcement.banner.collapse.clicked": [
        "sdVersion",
        "sessionId",
        "version",
        "context",
        "portalFrontendBuildKey"
    ],
    "portal.home.announcement.banner.expand.clicked": [
        "sdVersion",
        "sessionId",
        "version",
        "context",
        "portalFrontendBuildKey"
    ],
    "categories.fetch.all.failed": ["sdVersion", "sessionId", "version", "context", "portalFrontendBuildKey"],
    "category.articles.fetch.failed": ["sdVersion", "sessionId", "version", "context", "portalFrontendBuildKey"],
    "raise.request.cta.button": ["sdVersion", "sessionId", "version", "context", "portalFrontendBuildKey"]
}
